/**
 * handle google recaptcha
 * 
 * @jira FDZ-578
 * @date 2022-09-14
 * @author sh@sopg.de
 */
define('util/recaptcha',[
    'jquery',
    'underscore'
], function($, _) {
    'use strict';
    
    return {

        
        /**
         * execute recaptcha
         * returns token by deferred
         * 
         * @jira FDZ-578
         * @date 2022-09-14
         * @author sh@sopg.de
         * 
         * @returns $.Deferred
         */
        execute : function()
        {
            return this.require().then(function() {
                var oDef = new $.Deferred();

                grecaptcha.ready(function() {
                    grecaptcha.execute(window.cnf.grecaptcha, {action: 'submit'}).then(function(token) {
                        oDef.resolve({token:token});
                    });
                });
                    
                return oDef.promise();
            });
        },
        
        /**
         * satisfy requirements
         * 
         * @jira FDZ-578
         * @date 2022-09-14
         * @author sh@sopg.de
         * 
         * @returns $.Deferred
         */
        require : function()
        {
            var oDef = new $.Deferred();

            if(typeof grecaptcha === 'undefined') {
                $.ajax({
                    url: 'https://www.google.com/recaptcha/api.js?render=' + window.cnf.grecaptcha,
                    dataType: "script",
                    success: oDef.resolve
                  });
            } else {
                oDef.resolve();
            }

            return oDef.promise();
        },

        /**
         * verify given token
         * 
         * @jira FDZ-618
         * @date 2023-02-01
         * @author sh@sopg.de
         */
        verify : function()
        {
            return this.execute().then(function(ev) {
                var oDef = new $.Deferred();
            
                $.ajax({
                    url: window.cnf.host + window.cnf.api,
                    dataType: 'json',
                    type: 'post',
                    data: {
                        action: window.cnf.action.verify_recaptcha,
                        recaptcha_token: ev.token
                    },
                    complete:function(xhr) {
                        var bTokenVerify;

                        try {
                            bTokenVerify = xhr.responseJSON.success.verify;
                        } catch(e) {
                            console.log(e, xhr);

                            //send log
                            $.ajax({
                                url: window.cnf.host + window.cnf.api,
                                dataType: 'json',
                                type: 'post',
                                data: {
                                    action: 'log',
                                    error: e,
                                    origin: 'recaptcha::verify()',
                                    xhr: (typeof xhr.responseJSON === 'object' ? xhr.responseJSON : 'unknown'),
                                    responseText: xhr.responseText
                                }
                            });
                        } finally {
                            oDef.resolve({
                                token: ev.token,
                                token_verify: bTokenVerify
                            });
                        }
                    }
                });
                    
                return oDef.promise();
            });
        }
    }
});
